import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import "./css/IPODialog.css";
import {
  Radio,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";
import searchimg from "../../assets/searchningimg.svg";

const IPODialog = (
  { openstatus, closestatus, confirmationName, TitleName }
) => {
  console.log(TitleName)
  const [open, setopen] = useState(openstatus);
  const closeModal = () => {
    closestatus();
    setopen(false)
  }

  const closeModalOnsave = (that) => {

    closestatus(that);
    setopen(false);
  };
  const [selectionType, setselectionType] = useState('Broker Name');
  const toggleTab = (that) => {
    setselectionType(that);
    setsearchPlaceholder(that);
  }

  const [searchbyipo, setsearchbyipo] = useState('')
  const handleInput = (e) => {
    console.log(e);

  }

  const [searchPlaceholder, setsearchPlaceholder] = useState("Broker Name")
  const setPlaceholder = (that) => {
    setsearchPlaceholder(that);
  }

  const closeMOdal = () =>{
    closestatus('that');
    setopen(false);
  }
  const [maxWidth, setMaxWidth] = React.useState('xs');
  const [fullWidth, setFullWidth] = React.useState(true);
  useEffect(() => {
    if(confirmationName === "investorList"){
      setMaxWidth('sm')
    }else {
      setMaxWidth('xs')
    }
    
},[]);

  return (
    <>
      {open && (
        <Dialog
        fullWidth={fullWidth}
          maxWidth= {maxWidth}
          open={open}
          onClose={closeModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={{
              textAlign: "left",
              fontSize: "h5.fontSize",
              fontWeight: "normal",
              textTransform: "capitalize",
            }}
          >
            {
              confirmationName == "investorList" &&
              <p className="titlename">{TitleName}</p>

            }

            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </DialogTitle>
          <DialogContent>
            <DialogContentText
              id="alert-dialog-description"
            // sx={{ textAlign: "center" }}
            >
              {confirmationName === "deletepopup" && (
                <div className="popupdivflexfull nopadding">
                  <p className="headerSgtartname">
                    Are you sure you want to delete this record?
                  </p>
                  <br />

                  <div className="col-12 alighncet">
                    <button
                      type="button"
                      name="button"
                      className="makewhitcolor btnInuse btn-default makewhitcolor ml-15  makewhitcolor addMargin"
                      onClick={() => closeModalOnsave("yes")}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      name="button"
                      className="makewhitcolor btnInuse btn-default makewhitcolor addMargin"
                      onClick={() => closeModalOnsave("no")}
                    >
                      No
                    </button>
                  </div>
                </div>
              )}

              {confirmationName === "investorList" && (
                <>

                  <div className="addmargindematSearch ">
                    <FormControl component="fieldset">
                      <RadioGroup
                        className="radiowrapperSwitch"
                        row
                        aria-label="gender"
                        name="row-radio-buttons-group"
                        value={selectionType}

                      >
                        <FormControlLabel
                          className={selectionType == 'Broker Name' ? "RadiodivSwitch radioptionSwitch borderradio " : "RadiodivSwitch radioptionSwitch"}

                          value="Broker Name"
                          control={<Radio className="colorchange" />}
                          onChange={() => toggleTab('Broker Name')}
                          label="Broker Name"

                        />
                        <FormControlLabel
                          className={selectionType === 'DP ID & Client ID' ? "RadiodivSwitch radioptionSwitch borderradio " : "RadiodivSwitch radioptionSwitch"}

                          value="DP ID & Client ID"
                          control={<Radio className="colorchange" />}
                          onChange={() => toggleTab('DP ID & Client ID')}
                          label="DP ID & Client ID"

                        />

                      </RadioGroup>
                    </FormControl>
                  </div>

                  <div className="col-lg-12 col-md-12 col-12">
                    <div className=" sort customMarginSerc">
                      <div className="searchareaCustom">
                        <p>Enter Details</p>
                        <div className="makeitInputfield">
                          {/* <img src={searchimg} alt="searchimg" className="searchImg" /> */}
                          <input
                            type="text"
                            placeholder={searchPlaceholder}
                            name="search"
                            className="removeborder"
                            onInput={(e) => handleInput(e)}
                          />
                          <button className="searchbtn">Search</button>
                        </div>
                      </div>

                    </div>

                    <div className="table-responsive hideformob divTable">
                  <table className="table ipodialog">
                    <thead>
                      <tr>
                        <th>Broker Name</th>
                        <th >DP ID</th>
                        <th>Client ID</th>
                        {/* <th></th> */}
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <div className="alignradio">
                          <input type='radio' name="selectinvestor" className="s"/>
                          <p className="radioNm">Zerodha </p>
                          </div>
                          
                        </td>
                        <td>IN376353</td>
                        <td>3457963</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="alignradio">
                          <input type='radio' name="selectinvestor" className="s"/>
                          <p className="radioNm">Zerodha </p>
                          </div>
                          
                        </td>
                        <td>IN376353</td>
                        <td>3457963</td>
                      </tr>

                      <tr>
                        <td>
                          <div className="alignradio">
                          <input type='radio' name="selectinvestor" className="s"/>
                          <p className="radioNm">Zerodha </p>
                          </div>
                          
                        </td>
                        <td>IN376353</td>
                        <td>3457963</td>
                      </tr>

                      
                      </tbody>
                      </table>
                  </div>

                  <div className="col-md-6 text-end"><button type="button" name="button" className="clnsorde" onClick={closeMOdal}> PROCEED</button></div>
                  </div>
                </>
              )}







            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default IPODialog;
